import React from "react";
import Modal from "components/Modal/Modal";
import Button from "components/Button/Button";
import styles from "./ConfirmationModal.module.scss";

const ConfirmationModal = props => {
    const handleConfirm = () => {
        try {
            props.data.confirmAction();
            props.setShowModal(false)
        } catch (error) {
            console.log(error);
        }
    };
    return (
        <Modal
            className={styles.modal}
            setShowModal={props.setShowModal}
            
        >
            <div>
                <p className={styles["modal-heading"]}>{props.data.title}</p>

                <div className={styles["modal-content"]}>
                    {props.data.question}
                </div>

                <div className={styles["modal-footer"]}>
                    <Button
                        text="CANCEL"
                        color="secondary"
                        onClick={() => props.setShowModal(false)}
                    />
                    <Button
                        text="CONFIRM"
                        color="danger"
                        className={styles.create}
                        onClick={handleConfirm}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default ConfirmationModal;
